import React, { Suspense } from 'react';

import 'core-js/features/array/flat';
import 'core-js/features/object/values';
import 'core-js/features/string/pad-start';
import 'core-js/features/array/every';
import styles from './App.module.css';
import Header from './Header/Header';
import Page from './Page/Page';
import Footer from './Footer/Footer';
import ErrorBoundary from './ErrorBoundary';

function App() {
  return (
    <div className={styles.app}>
      <Suspense fallback=" ">
        <ErrorBoundary>
          <Header />
          <Page />
          <Footer />
        </ErrorBoundary>
      </Suspense>
    </div>
  );
}

export default App;
